// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Fj","subtitle":"Gj","contentWrap":"Hj","imgWrap":"Ij","heading":"Jj","copy":"Kj"};